import { createApp } from 'vue';
import RouteCardApp from './RouteCardApp.vue';
import { i18n } from '../../i18n';
import type { RouteCardPage } from './types';

const mountEl = document.getElementById('route-card-app');
const page = (window as unknown as { routeCardPage?: RouteCardPage }).routeCardPage;

if (mountEl && page) {
  const app = createApp(RouteCardApp, { page });
  app.use(i18n);
  app.mount(mountEl);
}
